import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getTagFoldersFeatureName, getTagFoldersFeatureTooltip } from '@/Constants/Constants';
import { usePremiumModal } from '@/Hooks/usePremiumModal';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import StyledTooltip from '../StyledTooltip/StyledTooltip';
import { c } from 'ttag';
const TagsSectionTitle = ({ features }) => {
    const entitledToFolders = features.hasFolders;
    const modal = usePremiumModal();
    const showPremiumAlert = useCallback(() => {
        modal.activate(getTagFoldersFeatureName());
    }, [modal]);
    if (entitledToFolders) {
        return (_jsx(_Fragment, { children: _jsx("div", { className: "title text-base md:text-sm", children: _jsx("span", { className: "font-bold", children: c('B4.Notes.TagsLinkedItems.Label').t `Folders` }) }) }));
    }
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "title text-base md:text-sm", children: [_jsx("span", { className: "font-bold", children: c('B4.Notes.TagsLinkedItems.Label').t `Tags` }), _jsx(StyledTooltip, { label: getTagFoldersFeatureTooltip(), children: _jsx("label", { className: "ml-1 cursor-pointer font-bold text-passive-2", onClick: showPremiumAlert, children: c('B4.Notes.TagsLinkedItems.Label').t `Folders` }) })] }) }));
};
export default observer(TagsSectionTitle);
